<mat-form-field class="select" appearance="outline">
  <mat-label>{{
    "features.product-comparison.selectLabelCompetitorProduct" | translate
  }}</mat-label>
  <mat-select
    (selectionChange)="handleCompetitorSelectChange($event)"
    [value]="$safeNavigationMigration(selectedCompetitor()?.ID)"
    [placeholder]="
      'pia.features.competitor-comparison.competitor-selection-modal-dialog.selectCompetitorPlaceholder'
        | translate
    "
  >
    <mat-select-trigger>
      @if (selectedCompetitorDisplay(); as displayName) {
        {{ displayName }}
      } @else {
        {{
          "features.competitor-comparison.competitor-selection-modal-dialog.selectCompetitorPlaceholder"
            | translate
        }}
      }
    </mat-select-trigger>

    @for (
      competitorWithBrand of competitorsGroupedByBrand();
      track competitorWithBrand.brand
    ) {
      <mat-optgroup
        class="opt-group font-3xs"
        [label]="competitorWithBrand.brand"
      >
        @for (competitor of competitorWithBrand.items; track competitor.ID) {
          <mat-option class="option font-xs" [value]="competitor.ID">
            <div class="option-inner">
              @if (competitor.benchmarkIconId) {
                <claas-icon
                  class="arrow-icon"
                  [iconId]="competitor.benchmarkIconId"
                  [namespace]="'pia'"
                  [size]="20"
                  [alt]="''"
                  [removeDefaultColor]="true"
                >
                </claas-icon>
              }
              <span class="option-text">{{ competitor.Name }}</span>
            </div>
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>
</mat-form-field>
